// extracted by mini-css-extract-plugin
module.exports = {"infoMessage":"_3b737a0","buttons":"_2de518c"};